import { createContext, useContext, useState } from 'react';

export const SidebarContext = createContext({
  openItemsId: [],
  setOpenItemsId: () => {}
});

export const useSidebarContext = () => useContext(SidebarContext);

export function SidebarContextProvider({ children }) {
  const [openItemsId, setOpenItemsId] = useState([]);

  return (
    <SidebarContext.Provider
      value={{
        openItemsId,
        setOpenItemsId
      }}>
      {children}
    </SidebarContext.Provider>
  );
}
